import { LiliBadge, LiliBadgeType } from '@lili/lili-frontend-common';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as WaitingIcon } from '../../../../../assets/icons/svg/colored-icons/ic-colored-badge-waiting.svg';
import { ReactComponent as Success } from '../../../../../assets/icons/svg/colored-icons/ic-colored-badge-success.svg';
import { TeamMemberInviteStatus } from '../../../../../types';

export const RoleItemInviteStatus = ({ status }: { status: TeamMemberInviteStatus }) => {
  const { t } = useTranslation();
  const statusMap = {
    [TeamMemberInviteStatus.ACTIVE]: (
      <LiliBadge
        id=''
        title={t('ACCOUNT_SETTINGS.TEAM.TABLE.STATUS_SENT')}
        type={LiliBadgeType.NEUTRAL}
        icon={<WaitingIcon />}
      />
    ),
    [TeamMemberInviteStatus.COMPLETED]: (
      <LiliBadge
        id=''
        title={t('ACCOUNT_SETTINGS.TEAM.TABLE.STATUS_ACTIVE')}
        type={LiliBadgeType.POSITIVE}
        icon={<Success />}
      />
    ),
  };

  return <div className='flex flex-row items-center gap-2'>{statusMap[status]}</div>;
};
